export enum CategoryType {
    SelectionCategories = 1,
    SelectionLocations = 2,
    JobGroups = 3, // previously called neighborhoods
    ScheduleShiftReasons = 4,
    SubCategories = 5,
    WorkdayExceptionCategories = 6,
    WarrantyCategories = 7,
    LeadSources = 9,
    LeadCategories = 10,
    LeadActivityTypes = 11,
    NAHBCodes = 12,
    VarianceCodes = 13,
    NonWorkdayExceptionCategories = 14,
    ScheduleItemPhases = 15,
    SelectionAllowances = 16,
    CustomFieldDropdownItems = 17,
}
